import styled from 'styled-components';

export const Container = styled.div``;
export const ContentHeader = styled.div`
  padding: 50px 30px 30px 30px;
`;
export const Content = styled.div`
  height: 500px;
  text-align: center;
  overflow-y: auto;
  embed {
    width: 100%;
    height: 580px;
    outline: 0;
    border: 0;
  }
`;
export const ContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #383838;
  padding: 12px 16px;
  button {
    background: linear-gradient(159.59deg, #53b2fe -80.66%, #065af3 162.47%);
    border-radius: 4px;
    display: inline-flex;
    outline: 0;
    border: 0;
    cursor: pointer;
    font-family: 'Lato';
    font-size: 12px;
    font-weight: 900;
    padding: 6px 16px;
    color: #fff;
    text-transform: uppercase;
  }
`;
